import { useEffect, useRef } from "react";
import { PostHogEvents, useTrackEvent } from "@/lib/posthog-events";
import { BackButton } from "./back-button";
import { TipCard } from "./tip-card";
import { useMagicMomentStore } from "./use-magic-moment-store";

const DAY2_TIPS = [
  {
    eyebrow: "Break the ice",
    body: "Ask something you're actually curious about. Teens can tell the difference between a real question and a checklist.",
  },
  {
    eyebrow: "Go a little deeper",
    body: "Ask what they'd do with a completely free Saturday. It tells you what they actually care about.",
  },
  {
    eyebrow: "Keep it playful",
    body: "Send a hot take — pineapple on pizza, the best cereal, the worst movie everyone pretends to love. Low-stakes debates get people talking fast.",
  },
] as const;

interface TipsDrawerProps {
  teenId?: string | null;
}

export function TipsDrawer({ teenId }: TipsDrawerProps) {
  const { track } = useTrackEvent();
  const viewTracked = useRef(false);
  const goBack = useMagicMomentStore((s) => s.goBack);

  useEffect(() => {
    if (!viewTracked.current) {
      viewTracked.current = true;
      track(PostHogEvents.DAY2_TIPS_VIEW, { teen_id: teenId });
    }
  }, []);

  const handleBack = () => {
    track(PostHogEvents.DAY2_TIPS_BACK, { teen_id: teenId });
    goBack();
  };

  return (
    <div className="rounded-t-2xl border-x border-t border-surfaces-z4 bg-surfaces-z3 px-4 pb-4 pt-4">
      <BackButton onClick={handleBack} />
      <div className="flex flex-col gap-1">
        <h3 className="text-base font-bold leading-5 tracking-[-0.16px] text-text-primary">
          Tips
        </h3>
        <p className="text-sm leading-5 text-text-secondary">
          If you&apos;re not sure what to say, these are a good place to start.
        </p>
      </div>
      <div className="mt-2 flex flex-col gap-2">
        {DAY2_TIPS.map((tip) => (
          <TipCard key={tip.eyebrow} eyebrow={tip.eyebrow}>
            {tip.body}
          </TipCard>
        ))}
      </div>
    </div>
  );
}
